import React from 'react';

import CollectionsIndicatorsV2 from './components/IndicatorsV2';

const CollectionsHome = () => {
  return (
    <div>
      <CollectionsIndicatorsV2 />
    </div>
  );
};

export default CollectionsHome;
